import styled from 'styled-components';
import { fromMd } from '../../constants/breakpoints';
export const StyledText = styled.p(({ theme, textAlign, textTransform, textType = 'paragraph', variant = 'primary' }) => {
    const textTypography = theme.typography.deprecated.text[textType][variant];
    return {
        fontFamily: textTypography.fontFamily,
        fontSize: textTypography.device.small.fontSize,
        fontWeight: textTypography.device.small.fontWeight,
        letterSpacing: textTypography.device.small.letterSpacing,
        lineHeight: textTypography.device.small.lineHeight,
        textAlign,
        textTransform,
        [fromMd]: {
            fontSize: textTypography.device.large.fontSize,
            fontWeight: textTypography.device.large.fontWeight,
            letterSpacing: textTypography.device.large.letterSpacing,
            lineHeight: textTypography.device.large.lineHeight,
        },
    };
});
//# sourceMappingURL=styles.js.map